<template>
  <div>
    <article v-if="inputLabel()" class="form-control-label">
      {{ inputLabel() }}
    </article>
    <v-select
      :label="label && label.length <= 25 ? label : null"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      v-model="computedValue"
      outlined
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :error="error"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholder"
      persistent-placeholder
      class="os-rounded os-select"
    ></v-select>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    label: {
      type: String,
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: null
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  methods: {
    inputLabel() {
      return this.label.length > 25 ? this.label : null
    }
  },
  mounted() {
    this.$emit('mounted');
  }
}
</script>

<style>
.v-menu__content {
  border-radius: 8px !important;
}
</style>
